import { z } from "zod";
import type { AuthStorage } from "../auth-storage";

export const AUDIO_SETTINGS_KEY = "frontier.audio.v1";
export const DEFAULT_AUDIO_SETTINGS = { muted: false, music: 0.28, effects: 0.6 };
const schema = z.object({
  muted: z.boolean(),
  music: z.number().finite().min(0).max(1),
  effects: z.number().finite().min(0).max(1),
}).strict();
export type AudioSettings = z.infer<typeof schema>;

export function readAudioSettings(storage: AuthStorage): AudioSettings {
  const saved = storage.getItem(AUDIO_SETTINGS_KEY);
  if (saved) {
    try {
      const parsed = schema.safeParse(JSON.parse(saved));
      if (parsed.success) return parsed.data;
    } catch { /* Invalid local preferences use the defaults. */ }
  }
  return { ...DEFAULT_AUDIO_SETTINGS };
}
